import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  CAlert,
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CProgress,
  CProgressBar,
  CRow,
  CSpinner,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CToast,
  CToastBody,
  CToastClose,
  CToaster,
  CTooltip,
} from "@coreui/react";

import axios from "axios";

// ⚠️ Alguns projetos exportam o AutoSelect como CJS (module.exports = ...)
// ou como named export. Isso causa: "Element type is invalid... but got: object".
// Aqui garantimos que AutoSelect será sempre uma função/classe React.
import AutoSelectImport from "../../../../common/autoselect";
const AutoSelect =
  (AutoSelectImport && AutoSelectImport.default) ? AutoSelectImport.default : AutoSelectImport;

import { GetLogProcessosDetails, GetFiliaisDetails } from "../../../../services";

/**
 * ====== NF Entrada Outras (OT) - Tela de Carga + Seleção + Envio ======
 * Refatorada no mesmo layout/UX da tela de NF Entrada (padrão),
 * ajustando endpoints e services para Entrada OT.
 */

const API_BASE =
  process.env.REACT_APP_INTEGRADOR_BAOBA_API ||
  "https://integradorbaoba.masterdaweb.net/api";

// Util: options para AutoSelect
const toOptions = (data, fieldLabel, fieldValue) =>
  Array.isArray(data)
    ? data.map((item) => ({ label: item[fieldLabel], value: item[fieldValue] }))
    : [];

// Util: data de hoje yyyy-mm-dd
const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;
};

const safeStr = (v) => (v == null ? "" : String(v));

export default class List extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    const d = todayISO();

    this.state = {
      ctrlList: [],
      filiais: [],

      id_filial: 0,
      nome_filial: "",
      operadora: "",

      filters: {
        nnf: "",
        demissaonfe: "",
        transportadora: "",
        filialNome: "",
        status: "ALL", // ALL | S | N
      },

      cargaParams: { startDate: d, endDate: d },

      loading: {
        page: false,
        filiais: false,
        ctrl: false,
        carga: false,
        envio: false,
        toggle: false,
      },
      banner: null,
      toasts: [],
      confirm: { show: false, mode: null }, // 'carga' | 'envio'
      progress: null,
    };

    this.toasterRef = React.createRef();
    this.toastId = 1;
  }

  async componentDidMount() {
    // valida AutoSelect logo no início (ajuda a identificar o erro rapidamente)
    if (typeof AutoSelect !== "function" && typeof AutoSelect !== "object") {
      // eslint-disable-next-line no-console
      console.warn("AutoSelect inválido:", AutoSelect);
    }
    await this.bootstrap();
  }

  bootstrap = async () => {
    await Promise.all([this.getFiliais(), this.getCTRL()]);
  };

  setLoading = (key, value) => {
    this.setState((prev) => ({
      loading: { ...prev.loading, [key]: value },
    }));
  };

  pushToast = (color, title, message, autohide = true) => {
    const id = this.toastId++;
    const toast = { id, color, title, message, autohide, visible: true };
    this.setState((prev) => ({ toasts: [toast, ...prev.toasts].slice(0, 6) }));
  };

  closeToast = (id) => {
    this.setState((prev) => ({
      toasts: prev.toasts.map((t) => (t.id === id ? { ...t, visible: false } : t)),
    }));
  };

  setBanner = (type, title, text) => {
    this.setState({ banner: { type, title, text } });
  };

  clearBanner = () => this.setState({ banner: null });

  getFiliais = async () => {
    this.setLoading("filiais", true);
    try {
      const list = await GetFiliaisDetails.FilialList();
      this.setState({ filiais: list?.data || [] });
    } catch (err) {
      console.error("Erro ao buscar filiais:", err);
      this.setBanner(
        "danger",
        "Falha ao carregar filiais",
        "Não foi possível obter a lista de filiais. Verifique sua conexão e tente novamente."
      );
      this.pushToast("danger", "Filiais", "Falha ao carregar filiais.");
    } finally {
      this.setLoading("filiais", false);
    }
  };

  getCTRL = async () => {
    this.setLoading("ctrl", true);
    try {
      const list = await GetLogProcessosDetails.getEntradaOT();
      this.setState({ ctrlList: list?.data || [] });
    } catch (err) {
      console.error("Erro ao buscar controle:", err);
      this.setBanner(
        "danger",
        "Falha ao carregar notas",
        "Não foi possível obter a lista de notas do controle. Tente novamente."
      );
      this.pushToast("danger", "Notas", "Falha ao carregar lista de notas.");
    } finally {
      this.setLoading("ctrl", false);
    }
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      filters: { ...prev.filters, [name]: value },
    }));
  };

  clearFilters = () => {
    this.setState({
      filters: {
        nnf: "",
        demissaonfe: "",
        transportadora: "",
        filialNome: "",
        status: "ALL",
      },
    });
  };

  applyFilters = () => {
    const { ctrlList, filters } = this.state;

    return (ctrlList || []).filter((item) => {
      const nnfOk = !filters.nnf || safeStr(item.nnf).includes(filters.nnf);
      const emiOk =
        !filters.demissaonfe || safeStr(item.demissaonfe).includes(filters.demissaonfe);

      const transpOk =
        !filters.transportadora ||
        safeStr(item.nome_fantasia)
          .toLowerCase()
          .includes(filters.transportadora.toLowerCase());

      const filialNome = safeStr(item?.filiai?.nome);
      const filialOk =
        !filters.filialNome ||
        filialNome.toLowerCase().includes(filters.filialNome.toLowerCase());

      const statusOk =
        filters.status === "ALL" ? true : safeStr(item.status) === filters.status;

      return nnfOk && emiOk && transpOk && filialOk && statusOk;
    });
  };

  handleStatusChange = async (id, currentIsS) => {
    this.setLoading("toggle", true);
    try {
      const newStatus = currentIsS ? "N" : "S";
      await GetLogProcessosDetails.EntradaOTUpdate({ id, status: newStatus });

      this.setState((prev) => ({
        ctrlList: prev.ctrlList.map((it) => (it.id === id ? { ...it, status: newStatus } : it)),
      }));
    } catch (error) {
      console.error("Erro ao atualizar status:", error);
      this.pushToast("danger", "Processar", "Erro ao atualizar status da nota.");
    } finally {
      this.setLoading("toggle", false);
    }
  };

  toggleAllFiltered = async (valueS) => {
    const filtered = this.applyFilters();
    const targets = filtered.filter((it) => (valueS ? it.status !== "S" : it.status === "S"));
    if (!targets.length) {
      this.pushToast(
        "info",
        "Seleção",
        valueS ? "Nada para marcar (já selecionado)." : "Nada para desmarcar."
      );
      return;
    }

    this.setLoading("toggle", true);
    try {
      for (const it of targets) {
        const newStatus = valueS ? "S" : "N";
        // eslint-disable-next-line no-await-in-loop
        await GetLogProcessosDetails.EntradaOTUpdate({ id: it.id, status: newStatus });
      }

      this.setState((prev) => ({
        ctrlList: prev.ctrlList.map((it) => {
          const isTarget = targets.some((t) => t.id === it.id);
          if (!isTarget) return it;
          return { ...it, status: valueS ? "S" : "N" };
        }),
      }));

      this.pushToast(
        "success",
        "Seleção",
        valueS ? "Notas filtradas marcadas para processar." : "Notas filtradas desmarcadas."
      );
    } catch (err) {
      console.error("Erro em seleção em massa:", err);
      this.pushToast("danger", "Seleção", "Falha ao alterar seleção em massa.");
    } finally {
      this.setLoading("toggle", false);
    }
  };

  handleSelectChange = (name, selected) => {
    this.setState({
      list: {
        ...this.state.list,
        [name]: selected?.value,
      },
      id_filial: selected?.value,
      nome_filial: selected?.label,
    });
    this.setState({ changed: true });
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleCargaParamsChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      cargaParams: { ...prev.cargaParams, [name]: value },
    }));
  };

  openConfirm = (mode) => {
    this.clearBanner();
    this.setState({ confirm: { show: true, mode } });
  };

  closeConfirm = () => this.setState({ confirm: { show: false, mode: null } });

  validateBeforeCarga = () => {
    const { id_filial, cargaParams } = this.state;
    if (!id_filial) {
      this.setBanner("warning", "Atenção", "Escolha uma filial antes de executar a carga.");
      this.pushToast("warning", "Carga", "Escolha uma filial.");
      return false;
    }
    if (!cargaParams.startDate || !cargaParams.endDate) {
      this.setBanner("warning", "Atenção", "Informe o período (De/Até) para a carga.");
      this.pushToast("warning", "Carga", "Informe o período.");
      return false;
    }
    if (cargaParams.endDate < cargaParams.startDate) {
      this.setBanner("warning", "Atenção", "A data final deve ser maior/igual à data inicial.");
      this.pushToast("warning", "Carga", "Período inválido.");
      return false;
    }
    return true;
  };

  validateBeforeEnvio = () => {
    const { id_filial, operadora, ctrlList } = this.state;

    if (!id_filial) {
      this.setBanner("warning", "Atenção", "Escolha uma filial antes do envio.");
      this.pushToast("warning", "Envio", "Escolha uma filial.");
      return false;
    }
    if (!safeStr(operadora).trim()) {
      this.setBanner("warning", "Atenção", "Escolha uma operadora para envio.");
      this.pushToast("warning", "Envio", "Escolha uma operadora.");
      return false;
    }
    const hasSelected = (ctrlList || []).some((it) => it.status === "S");
    if (!hasSelected) {
      this.setBanner(
        "warning",
        "Atenção",
        "Pelo menos uma nota deve estar marcada (Processar) antes do envio."
      );
      this.pushToast("warning", "Envio", "Marque ao menos uma nota para processar.");
      return false;
    }
    return true;
  };

  doCarga = async () => {
    if (!this.validateBeforeCarga()) return;

    const { id_filial, cargaParams } = this.state;

    this.setLoading("carga", true);
    this.setState({ progress: { label: "Executando carga…", value: 30 } });

    try {
      const res = await axios.get(`${API_BASE}/nf_entradaOT/CargaNFEntradaOT`, {
        params: {
          startDate: cargaParams.startDate,
          endDate: cargaParams.endDate,
          cd_estabelecimento: id_filial,
        },
        timeout: 120000,
      });

      const message = res?.data?.message || "Carga finalizada.";
      this.setBanner("success", "Carga concluída", message);
      this.pushToast("success", "Carga", message);

      this.setState({ progress: { label: "Atualizando lista…", value: 80 } });
      await this.getCTRL();
      this.setState({ progress: { label: "Pronto", value: 100 } });
    } catch (err) {
      console.error("Erro na carga:", err);
      const serverMsg = err?.response?.data?.message || err?.response?.data?.error;
      const msg = serverMsg || "Erro ao executar carga. Tente novamente.";
      const status = err?.response?.status;

      this.setBanner("danger", "Falha na carga", status ? `[HTTP ${status}] ${msg}` : msg);
      this.pushToast("danger", "Carga", msg);
    } finally {
      setTimeout(() => this.setState({ progress: null }), 900);
      this.setLoading("carga", false);
      this.closeConfirm();
    }
  };

  CallApiEntradaOT = async (id_log) => {
    const { id_filial, operadora } = this.state;

    const res = await axios.get(`${API_BASE}/nf_entradaOT/getNFEntradaOT`, {
      params: { cd_estabelecimento: id_filial, operadora, id_log },
      timeout: 180000,
    });

    return res?.data;
  };

  doEnvio = async () => {
    if (!this.validateBeforeEnvio()) return;

    const { id_filial, operadora, nome_filial } = this.state;

    this.setLoading("envio", true);
    this.setState({ progress: { label: "Iniciando envio…", value: 20 } });

    try {
      const data = {
        nome: "Entrada OT NFs",
        mensagem: "Iniciada",
        status: "Iniciada",
        cd_estabelecimento: id_filial,
        operadora,
      };

      const log = await GetLogProcessosDetails.AddLogProcessos(data);
      const idLog = log?.data?.id;

      if (!idLog) {
        throw new Error("Não foi possível criar o log do processo (id ausente).");
      }

      this.setState({ progress: { label: "Disparando processamento…", value: 55 } });

      const result = await this.CallApiEntradaOT(idLog);

      const msg =
        result?.message ||
        result?.mensagem ||
        "Processamento disparado. Acompanhe a execução no log.";

      const meta =
        typeof result === "object"
          ? {
              enviados: result?.enviados,
              adiados: result?.adiados,
              erros: result?.erros,
              erros_confirmacao: result?.erros_confirmacao,
            }
          : null;

      this.setBanner(
        "info",
        "Envio iniciado",
        meta
          ? `${msg} | enviados=${meta.enviados ?? "-"} adiados=${meta.adiados ?? "-"} erros=${
              meta.erros ?? "-"
            }`
          : msg
      );
      this.pushToast("info", "Envio", msg);

      this.setState({ progress: { label: "Abrindo acompanhamento…", value: 90 } });

      this.props.history.push({
        pathname: "/admin/entrada/list/",
        state: {
          id_filial,
          nome_filial,
          operadora,
          processo: "Entrada OT NFs",
          id_log: idLog,
        },
      });
    } catch (err) {
      console.error("Erro no envio:", err);
      const serverMsg = err?.response?.data?.message || err?.response?.data?.error;
      const msg = serverMsg || err?.message || "Erro ao iniciar envio.";
      const status = err?.response?.status;

      const isLocked = status === 409;
      this.setBanner(
        isLocked ? "warning" : "danger",
        isLocked ? "Processo já em execução" : "Falha no envio",
        status ? `[HTTP ${status}] ${msg}` : msg
      );
      this.pushToast(isLocked ? "warning" : "danger", "Envio", msg);
    } finally {
      setTimeout(() => this.setState({ progress: null }), 900);
      this.setLoading("envio", false);
      this.closeConfirm();
    }
  };

  countSelected = () => (this.state.ctrlList || []).filter((it) => it.status === "S").length;

  renderStatusBadge = (status) => {
    if (status === "S") return <CBadge color="success">Selecionada</CBadge>;
    return <CBadge color="secondary">Não</CBadge>;
  };

  render() {
    const { loading, filters, cargaParams, operadora, filiais, banner, confirm, progress } =
      this.state;

    const filteredList = this.applyFilters();
    const selectedCount = this.countSelected();

    const operadoras = ["Next", "Unilog"];
    const busy = loading.filiais || loading.ctrl || loading.carga || loading.envio;

    return (
      <CRow>
        <CCol xs={12}>
          <CToaster ref={this.toasterRef} placement="top-end">
            {this.state.toasts.map((t) => (
              <CToast
                key={t.id}
                visible={t.visible}
                color={t.color}
                autohide={t.autohide}
                delay={3500}
                onClose={() => this.closeToast(t.id)}
                className="text-white"
              >
                <div className="d-flex">
                  <CToastBody>
                    <div className="fw-semibold">{t.title}</div>
                    <div>{t.message}</div>
                  </CToastBody>
                  <CToastClose className="me-2 m-auto" white />
                </div>
              </CToast>
            ))}
          </CToaster>

          {(loading.filiais || loading.ctrl) && (
            <div className="text-center my-2">
              <CSpinner color="success" />
            </div>
          )}

          {banner && (
            <CAlert color={banner.type} dismissible onClose={this.clearBanner} className="mb-3">
              <div className="fw-semibold">{banner.title}</div>
              <div>{banner.text}</div>
            </CAlert>
          )}

          {progress && (
            <div className="mb-3">
              <div className="d-flex justify-content-between mb-1">
                <small className="text-muted">{progress.label}</small>
                <small className="text-muted">{progress.value}%</small>
              </div>
              <CProgress>
                <CProgressBar value={progress.value} animated />
              </CProgress>
            </div>
          )}

          <CCard className="mb-4 shadow-sm">
            <CCardHeader className="py-3">
              <CRow className="g-3 align-items-center">
                <CCol md={2}>
                  <div className="d-flex align-items-center gap-2">
                    <strong>NFs Outras Entradas</strong>
                    <CBadge color="info">{filteredList.length}</CBadge>
                  </div>
                  <small className="text-muted">Selecionadas: {selectedCount}</small>
                </CCol>

                <CCol md={10}>
                  <div className="d-flex flex-wrap gap-3 align-items-end justify-content-end">
                    <div style={{ minWidth: 260 }}>
                      <CFormLabel className="mb-1">
                        <strong>Filial</strong>
                      </CFormLabel>
                      <AutoSelect
                        className="basic-single"
                        onChange={this.handleSelectChange}
                        isSearchable
                        name="id_filial"
                        label="Escolha uma Filial"
                        options={toOptions(filiais, "nome", "cd_estabelecimento")}
                      />
                    </div>

                    <div>
                      <CFormLabel className="mb-1">
                        <strong>De</strong>
                      </CFormLabel>
                      <CFormInput
                        type="date"
                        name="startDate"
                        value={cargaParams.startDate}
                        onChange={this.handleCargaParamsChange}
                      />
                    </div>

                    <div>
                      <CFormLabel className="mb-1">
                        <strong>Até</strong>
                      </CFormLabel>
                      <CFormInput
                        type="date"
                        name="endDate"
                        value={cargaParams.endDate}
                        onChange={this.handleCargaParamsChange}
                      />
                    </div>

                    <div>
                      <CTooltip content="Busca NFs no OMIE e atualiza a fila de processamento">
                        <CButton
                          color="primary"
                          disabled={loading.carga || loading.envio}
                          onClick={() => this.openConfirm("carga")}
                        >
                          {loading.carga ? (
                            <>
                              <CSpinner size="sm" className="me-2" />
                              Carregando...
                            </>
                          ) : (
                            "Efetuar Carga"
                          )}
                        </CButton>
                      </CTooltip>
                    </div>
                  </div>
                </CCol>
              </CRow>
            </CCardHeader>

            <CCardBody>
              <CRow className="g-3 align-items-end">
                <CCol md={7}>
                  <div className="d-flex flex-wrap gap-2 align-items-end">
                    <div style={{ width: 120 }}>
                      <CFormLabel className="mb-1">NNF</CFormLabel>
                      <CFormInput
                        placeholder="NNF"
                        name="nnf"
                        value={filters.nnf}
                        onChange={this.handleFilterChange}
                      />
                    </div>

                    <div style={{ width: 170 }}>
                      <CFormLabel className="mb-1">Emissão</CFormLabel>
                      <CFormInput
                        type="date"
                        name="demissaonfe"
                        value={filters.demissaonfe}
                        onChange={this.handleFilterChange}
                      />
                    </div>

                    <div style={{ minWidth: 220 }}>
                      <CFormLabel className="mb-1">Transportadora</CFormLabel>
                      <CFormInput
                        placeholder="Nome da transportadora"
                        name="transportadora"
                        value={filters.transportadora}
                        onChange={this.handleFilterChange}
                      />
                    </div>

                    <div style={{ minWidth: 220 }}>
                      <CFormLabel className="mb-1">Filial (texto)</CFormLabel>
                      <CFormInput
                        placeholder="Filial"
                        name="filialNome"
                        value={filters.filialNome}
                        onChange={this.handleFilterChange}
                      />
                    </div>

                    <div style={{ width: 160 }}>
                      <CFormLabel className="mb-1">Status</CFormLabel>
                      <CFormSelect
                        name="status"
                        value={filters.status}
                        onChange={this.handleFilterChange}
                      >
                        <option value="ALL">Todos</option>
                        <option value="S">Selecionadas</option>
                        <option value="N">Não selecionadas</option>
                      </CFormSelect>
                    </div>

                    <div className="d-flex gap-2">
                      <CButton color="secondary" variant="outline" onClick={this.clearFilters}>
                        Limpar
                      </CButton>

                      <CTooltip content="Marca todas as notas da lista filtrada como 'Processar'">
                        <CButton
                          color="success"
                          variant="outline"
                          disabled={loading.toggle || busy}
                          onClick={() => this.toggleAllFiltered(true)}
                        >
                          Selecionar filtradas
                        </CButton>
                      </CTooltip>

                      <CTooltip content="Desmarca todas as notas da lista filtrada">
                        <CButton
                          color="danger"
                          variant="outline"
                          disabled={loading.toggle || busy}
                          onClick={() => this.toggleAllFiltered(false)}
                        >
                          Desmarcar filtradas
                        </CButton>
                      </CTooltip>
                    </div>
                  </div>
                </CCol>

                <CCol md={5}>
                  <div className="p-3 rounded border bg-light">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="fw-semibold">Envio</div>
                      <small className="text-muted">
                        Selecionadas: <strong>{selectedCount}</strong>
                      </small>
                    </div>

                    <CRow className="g-2 align-items-end">
                      <CCol md={5}>
                        <CFormLabel className="mb-1">Operadora</CFormLabel>
                        <CFormSelect
                          name="operadora"
                          value={operadora}
                          onChange={this.handleChange}
                        >
                          <option value="" disabled>
                            Selecione...
                          </option>
                          {operadoras.map((op) => (
                            <option key={op} value={op}>
                              {op}
                            </option>
                          ))}
                        </CFormSelect>
                      </CCol>

                      <CCol md={7} className="d-grid">
                        <CButton
                          color="dark"
                          disabled={loading.envio || loading.carga}
                          onClick={() => this.openConfirm("envio")}
                        >
                          {loading.envio ? (
                            <>
                              <CSpinner size="sm" className="me-2" />
                              Enviando...
                            </>
                          ) : (
                            "Enviar selecionadas"
                          )}
                        </CButton>
                        <small className="text-muted mt-1">
                          O processamento ocorre no backend; acompanhe pelo log.
                        </small>
                      </CCol>
                    </CRow>
                  </div>
                </CCol>
              </CRow>

              <div className="mt-3">
                <CTable hover responsive bordered small className="align-middle">
                  <CTableHead color="dark">
                    <CTableRow>
                      <CTableHeaderCell style={{ width: 130 }}>Nota</CTableHeaderCell>
                      <CTableHeaderCell>Transportadora</CTableHeaderCell>
                      <CTableHeaderCell style={{ width: 150 }}>Emissão</CTableHeaderCell>
                      <CTableHeaderCell style={{ width: 220 }}>Filial</CTableHeaderCell>
                      <CTableHeaderCell style={{ width: 140 }}>Processar</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>

                  <CTableBody>
                    {filteredList.map((item) => {
                      const isS = item.status === "S";
                      return (
                        <CTableRow key={item.id}>
                          <CTableDataCell className="fw-semibold">{item.nnf}</CTableDataCell>
                          <CTableDataCell>{item.nome_fantasia}</CTableDataCell>
                          <CTableDataCell>{item.demissaonfe}</CTableDataCell>
                          <CTableDataCell>{item?.filiai?.nome}</CTableDataCell>
                          <CTableDataCell>
                            <div className="d-flex align-items-center gap-2">
                              <CFormCheck
                                checked={isS}
                                disabled={loading.toggle}
                                onChange={() => this.handleStatusChange(item.id, isS)}
                              />
                              {this.renderStatusBadge(item.status)}
                            </div>
                          </CTableDataCell>
                        </CTableRow>
                      );
                    })}

                    {!filteredList.length && (
                      <CTableRow>
                        <CTableDataCell colSpan={5}>
                          <div className="text-center text-muted py-4">
                            Nenhuma nota encontrada com os filtros atuais.
                          </div>
                        </CTableDataCell>
                      </CTableRow>
                    )}
                  </CTableBody>
                </CTable>
              </div>
            </CCardBody>
          </CCard>

          <CModal visible={confirm.show} onClose={this.closeConfirm} alignment="center">
            <CModalHeader>
              <CModalTitle>
                {confirm.mode === "carga" ? "Confirmar carga" : "Confirmar envio"}
              </CModalTitle>
            </CModalHeader>
            <CModalBody>
              {confirm.mode === "carga" ? (
                <>
                  <div className="fw-semibold mb-1">Deseja executar a carga no período informado?</div>
                  <div className="text-muted">
                    Essa ação pode levar alguns minutos, dependendo do volume e das limitações da OMIE.
                  </div>
                </>
              ) : (
                <>
                  <div className="fw-semibold mb-1">Deseja enviar as notas selecionadas?</div>
                  <div className="text-muted">
                    O backend iniciará o processamento e você poderá acompanhar no log.
                  </div>
                </>
              )}
            </CModalBody>
            <CModalFooter>
              <CButton color="secondary" variant="outline" onClick={this.closeConfirm}>
                Cancelar
              </CButton>
              <CButton
                color={confirm.mode === "carga" ? "primary" : "dark"}
                onClick={confirm.mode === "carga" ? this.doCarga : this.doEnvio}
                disabled={confirm.mode === "carga" ? loading.carga : loading.envio}
              >
                {confirm.mode === "carga" ? "Executar carga" : "Enviar agora"}
              </CButton>
            </CModalFooter>
          </CModal>
        </CCol>
      </CRow>
    );
  }
}
